import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import styles from './styles.module.scss';
import clsx from 'clsx';
import AntSwitch from '@/components/atoms/AntSwitch';
import {
  PowerSwitchState,
  PowerUnit,
  PowerSwitch,
  PowerUnitState,
} from '@/slicers/operation_page';
import { Button as MaterialButton } from '@material-ui/core';
import { CustomButton } from '@/components/atoms/CustomButton';

type SwitchSimulator64CHProps = {
  handleClickSwitchButton: (args: {
    unitNumber: number;
    switchNumber: number;
    state:
      | PowerSwitchState.ON
      | PowerSwitchState.OFF
      | PowerSwitchState.UNKNOWN;
  }) => void;
  units: PowerUnit[];
  groupIdx: number;
};

const SwitchSimulator64CH: React.FC<SwitchSimulator64CHProps> = ({
  handleClickSwitchButton,
  units,
  groupIdx,
}) => {
  const switchContainer = (unitNumber: number, powerSwitch?: PowerSwitch) => {
    if (!powerSwitch || powerSwitch.state === PowerSwitchState.UNKNOWN) {
      return <div>不明</div>;
    }

    const nextState =
      powerSwitch.state === PowerSwitchState.ON
        ? PowerSwitchState.OFF
        : PowerSwitchState.ON;

    return (
      <AntSwitch
        checked={powerSwitch.state === PowerSwitchState.ON}
        onClick={(event) =>
          handleClickSwitchButton({
            state: nextState,
            unitNumber,
            switchNumber: powerSwitch.number,
          })
        }
      />
    );
  };

  const hashUnits = units.reduce<Record<string, PowerUnit>>((obj, unit) => {
    obj[unit.number] = unit;
    return obj;
  }, {});

  return (
    <FormGroup>
      <div className={styles.container}>
        {/* <div>PID:{moduleWith.deviceCode}</div> */}
        <div className={styles.module_container}>
          {[1, 2, 3, 4].map((unitNum) => {
            const unit = hashUnits[groupIdx * 4 + unitNum] || {
              state: PowerUnitState.READY,
              number: unitNum,
              switchesByNumber: {},
            };

            return (
              <div className={styles.unit_wrapper} key={`unit_${unit.number}`}>
                <div className={styles.unit_container}>
                  {unit.state === PowerUnitState.LOADING ? (
                    <div className={styles.power_unit_state_loading_container}>
                      <div>接続待機中</div>
                    </div>
                  ) : (
                    [0, 1, 2, 3].map((swtNum) => {
                      const powerSwitch: PowerSwitch | undefined =
                        unit.switchesByNumber[swtNum];

                      return (
                        <div
                          aria-disabled={!powerSwitch}
                          className={styles.switch_wrapper}
                          key={swtNum}
                        >
                          <Typography component="div">
                            <Grid
                              component="label"
                              container
                              alignItems="center"
                              spacing={1}
                            >
                              <Grid item>
                                <div className={styles.switch_button_wrapper}>
                                  {switchContainer(unitNum, powerSwitch)}
                                </div>
                                <div className={styles.switch_button_container}>
                                  <CustomButton
                                    color="error"
                                    className={styles.switch_button}
                                    onClick={(event) =>
                                      handleClickSwitchButton({
                                        unitNumber: unit.number,
                                        switchNumber: powerSwitch.number,
                                        state: PowerSwitchState.ON,
                                      })
                                    }
                                  >
                                    ON
                                  </CustomButton>
                                  <CustomButton
                                    color="success"
                                    className={styles.switch_button}
                                    onClick={(event) =>
                                      handleClickSwitchButton({
                                        unitNumber: unit.number,
                                        switchNumber: powerSwitch.number,
                                        state: PowerSwitchState.OFF,
                                      })
                                    }
                                  >
                                    OFF
                                  </CustomButton>
                                  <MaterialButton
                                    variant="contained"
                                    className={clsx(
                                      styles.switch_button,
                                      styles.switch_button_unknows
                                    )}
                                    onClick={(event) =>
                                      handleClickSwitchButton({
                                        unitNumber: unit.number,
                                        switchNumber: powerSwitch.number,
                                        state: PowerSwitchState.UNKNOWN,
                                      })
                                    }
                                  >
                                    不明
                                  </MaterialButton>
                                </div>
                              </Grid>
                            </Grid>
                          </Typography>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </FormGroup>
  );
};

export default SwitchSimulator64CH;
